import Reflux from 'reflux';

const actions = Reflux.createActions({
	// items
	loadItem: {asyncResult: true},
	loadItems: {asyncResult: true},
	loadItemsDone: {},
	loadItemCount: {asyncResult: true},
	// loadItemCountFromProperty: {asyncResult: true},
	loadFacets: {asyncResult: true},
	facetsLoaded: {},
	loadItemSheet: {},

	selectProperty: {},
	selectPropertyById: {}, // special action for external calls
	selectProperties: {},
	selectModel: {},

	nextItemListPage: {},
	resetItemListPage: {},

	// accessories
	loadAccessory: {asyncResult: true},
	loadAccessories: {asyncResult: true},
	loadAccessoriesDone: {},
	loadAccessoryCount: {asyncResult: true},
	// loadAccessoryCountFromProperty: {asyncResult: true},
	loadAccessoryIdsForItems: {asyncResult: true}, // special action for accessories
	loadAccessoryFacets: {asyncResult: true},
	accessoryFacetsLoaded: {},
	loadAccessorySheet: {},

	selectAccessoryProperty: {},
	selectAccessoryProperties: {},

	nextAccessoryListPage: {}, // TODO
	resetAccessoryListPage: {}, // TODO

	// general
	initializeWizards: {},
	changeConfiguration: {},

	// wrapper tabs
	updateTabs: {},
	toggleTab: {},
	activeTab: {},
	unactiveTab: {},
	selectTab: {},
	unselectTab: {},

	windowResize: {},

	showSheet: {},
	closeSheet: {},

	wizLoading: {},
	wizLoadingDone: {}
});

export default actions;
